import { useEffect, useState } from 'react';
import { isSameDay } from "baseui/datepicker/utils"; // Optional utility

function getRelativeTime(dateString) {
  const now = new Date();
  const addedOnDate = new Date(dateString);
  const differenceInSeconds = Math.floor((now - addedOnDate) / 1000);

  if (isSameDay(now, addedOnDate)) {
    return 'Recent';
  }

  if (differenceInSeconds < 60) {
    return 'just now';
  } else if (differenceInSeconds < 3600) {
    const minutes = Math.floor(differenceInSeconds / 60);
    return `${minutes} Min${minutes > 1 ? 's' : ''}`;
  } else if (differenceInSeconds < 86400) {
    const hours = Math.floor(differenceInSeconds / 3600);
    return `${hours} Hr${hours > 1 ? 's' : ''}`;
  } else {
    const days = Math.floor(differenceInSeconds / 86400);
    return `${days} Day${days > 1 ? 's' : ''}`;
  }
}

export default function QuestionTimestamp({ addedOn, icon }) {
  const [relativeTime, setRelativeTime] = useState(getRelativeTime(addedOn));

  useEffect(() => {
    const intervalId = setInterval(() => {
      setRelativeTime(getRelativeTime(addedOn));
    }, 60000); // Update every minute

    return () => clearInterval(intervalId); // Cleanup on unmount
  }, [addedOn]);

  return <p>{icon}&nbsp;{relativeTime}</p>;
}
